import React from 'react'

import OrderState, { OrderStateTagProps } from 'common/components/statuses/order_state'

export const VendorOrderState = (props: OrderStateTagProps) => (
  <OrderState
    {...props}
    texts={{
      ORDERED: {
        ORDERED_REQUESTED: 'Order Requested',
      },
    }}
  />
)
